import byteliveApi from "./api/byteliveApi";
import { objectToQueryString } from "../utils";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const livereplayList = (payload) => {
    return (dispatch) => {
        const queryString = objectToQueryString(payload);
        return byteliveApi
            .get(`/livereplay${queryString}`)
            .then((data) => {
                let result = { ...data };
                result.results = result.results.map((res) => {
                    return { ...res, status: "processed" };
                });
                return result;
            })
            .catch((error) => {
                throw error;
            });
    };
};

export const livereplayDelete = (id) => {
    return (dispatch) => {
        return byteliveApi
            .delete(`/livereplay/admin/${id}`)
            .then((data) => {
                return data;
            })
            .catch((error) => {
                throw error;
            });
    };
};
